import axios from "axios";
import { authHeader } from "../../authServices/auth.header";

const API_URL = process.env.VUE_APP_ROOT_API;
// Get Device Profile List
class DeviceProfileService {
  async getDeviceProfileList(filter = "") {
    return await axios
      .get(API_URL + "pbx-app/device-profile" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get Pbx Server details
  async getDeviceProfileDetail(device_id) {
    return await axios
      .get(API_URL + `pbx-app/device-profile?id=${device_id}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // add Pbx Server details
  async addDeviceProfileDetail(data) {
    return await axios
      .post(API_URL + "pbx-app/device-profile", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update Pbx Server details
  async updateDeviceProfileDetail(device_proofile_id, data) {
    return await axios
      .put(API_URL + "pbx-app/device-profile/" + device_proofile_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update Pbx Server details
  async updateDeviceProfileStatus(device_proofile_id, data) {
    return await axios
      .patch(API_URL + "pbx-app/device-profile/" + device_proofile_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new DeviceProfileService();
